(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (window.__cartDrawerInit) return;
    window.__cartDrawerInit = true;

    function getDrawer() {
      return document.getElementById('cart-drawer');
    }

    function lockScroll() {
      if (window.lenis && typeof window.lenis.stop === 'function') window.lenis.stop();
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    function unlockScroll() {
      if (window.lenis && typeof window.lenis.start === 'function') window.lenis.start();
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    function openDrawer() {
      const d = getDrawer();
      if (!d) return;
      if (typeof d.showModal === 'function' && !d.open) {
        d.showModal();
      } else if (!d.hasAttribute('open')) {
        d.setAttribute('open', '');
      }
      lockScroll();
    }

    function closeDrawer() {
      const d = getDrawer();
      if (!d) return;
      if (typeof d.close === 'function' && d.open) {
        d.close();
      } else {
        d.removeAttribute('open');
      }
      unlockScroll();
    }

    function updateCounts(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = '(' + count + ')';
      });
    }

    async function refreshDrawer() {
      try {
        const res = await fetch('/?sections=cart-drawer');
        const data = await res.json();
        const html = data['cart-drawer'];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-cart-drawer-content]');
        const cur = document.querySelector('[data-cart-drawer-content]');
        if (next && cur) cur.replaceWith(next);
      } catch (err) {
        console.error('Cart drawer refresh failed:', err);
      }
    }

    async function changeLine(key, quantity, trigger) {
      if (trigger) trigger.disabled = true;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity }),
        });
        const cart = await res.json();
        if (cart && typeof cart.item_count === 'number') updateCounts(cart.item_count);
      } catch (err) {
        console.error('Cart change failed:', err);
      }
      await refreshDrawer();
    }

    async function addToCart(form) {
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        const result = await res.json();
        if (!res.ok || result.status) {
          console.error('Add to cart failed:', result);
          return;
        }
        const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartRes.json();
        if (cart && typeof cart.item_count === 'number') updateCounts(cart.item_count);
        await refreshDrawer();
        openDrawer();
      } catch (err) {
        console.error('Add to cart error:', err);
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    }

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (!action.includes('/cart/add')) return;
      event.preventDefault();
      addToCart(form);
    });

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-cart-open]');
      if (opener) {
        event.preventDefault();
        openDrawer();
        return;
      }

      const closer = event.target.closest('[data-cart-close]');
      if (closer) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      const removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        event.preventDefault();
        const key = removeBtn.getAttribute('data-cart-remove');
        if (!key) return;
        changeLine(key, 0, removeBtn);
        return;
      }

      const changeBtn = event.target.closest('[data-cart-change]');
      if (changeBtn) {
        event.preventDefault();
        const key = changeBtn.getAttribute('data-cart-change');
        const qty = parseInt(changeBtn.getAttribute('data-quantity'), 10);
        if (!key || isNaN(qty)) return;
        changeLine(key, qty, changeBtn);
        return;
      }

      const d = getDrawer();
      if (d && d.open && event.target === d) {
        closeDrawer();
      }
    });

    // ESC and other native close paths
    document.addEventListener('close', (event) => {
      if (event.target && event.target.id === 'cart-drawer') unlockScroll();
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-staggered"]) return;
  try {
    
  (function () {
    const container = document.querySelector('.collection-page--staggered .collection-page__products');
    if (!container) return;

    const inquireText = container.querySelector('.collection-page__inquire-text');
    const primarySpan = container.querySelector('.collection-page__inquire-primary');
    const secondarySpan = container.querySelector('.collection-page__inquire-secondary');
    const subtext = container.querySelector('.collection-page__inquire-subtext');
    if (!inquireText || !primarySpan || !secondarySpan) return;

    const defaultPrimary = container.dataset.defaultPrimary || primarySpan.textContent;
    const defaultSecondary = container.dataset.defaultSecondary || secondarySpan.textContent;
    const defaultSubtext = container.dataset.defaultSubtext || (subtext ? subtext.textContent : '');

    let hoverDepth = 0;

    function applyDefault() {
      primarySpan.textContent = defaultPrimary;
      secondarySpan.textContent = defaultSecondary;
      secondarySpan.hidden = false;
      if (subtext) subtext.textContent = defaultSubtext;
      inquireText.classList.remove('collection-page__inquire-text--active');
    }

    function applyProduct(product) {
      const title = product.dataset.productTitle || '';
      const verbiage = product.dataset.productVerbiage || '';
      primarySpan.textContent = title;
      secondarySpan.textContent = verbiage;
      secondarySpan.hidden = verbiage === '';
      if (subtext) subtext.textContent = defaultSubtext;
      inquireText.classList.add('collection-page__inquire-text--active');
    }

    container.addEventListener('pointerenter', (event) => {
      const image = event.target.closest('.collection-product__image');
      if (!image || !container.contains(image)) return;
      hoverDepth += 1;
      applyProduct(image.closest('.collection-product'));
    }, true);

    container.addEventListener('pointerleave', (event) => {
      const image = event.target.closest('.collection-product__image');
      if (!image || !container.contains(image)) return;
      hoverDepth = Math.max(0, hoverDepth - 1);
      if (hoverDepth === 0) applyDefault();
    }, true);
  })();

  (function () {
    let observer = null;

    async function loadNext(button) {
      const url = button.getAttribute('href');
      if (!url || button.dataset.loading === 'true') return;

      button.dataset.loading = 'true';

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to fetch next page');

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const currentGrid = document.querySelector('.collection-page__product-grid');
        const newGrid = parsed.querySelector('.collection-page__product-grid');

        if (currentGrid && newGrid) {
          while (newGrid.firstElementChild) {
            currentGrid.appendChild(newGrid.firstElementChild);
          }
        }

        const newButton = parsed.querySelector('.collection-page__load-more');
        if (newButton) {
          button.setAttribute('href', newButton.getAttribute('href'));
        } else {
          const pagination = button.closest('.collection-page__pagination');
          if (pagination) {
            if (observer) observer.disconnect();
            pagination.remove();
          }
        }
      } catch (error) {
        console.error('[collection load-more]', error);
      } finally {
        button.dataset.loading = 'false';
      }
    }

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.collection-page__load-more');
      if (!button) return;
      event.preventDefault();
      loadNext(button);
    });

    const pagination = document.querySelector('.collection-page--staggered .collection-page__pagination');
    if (pagination && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const button = pagination.querySelector('.collection-page__load-more');
          if (button) loadNext(button);
        });
      }, { rootMargin: '800px 0px' });
      observer.observe(pagination);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    let observer = null;

    async function loadNext(button) {
      const url = button.getAttribute('href');
      if (!url || button.dataset.loading === 'true') return;

      button.dataset.loading = 'true';

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to fetch next page');

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const currentGrid = document.querySelector('.collection-page__product-grid');
        const newGrid = parsed.querySelector('.collection-page__product-grid');

        if (currentGrid && newGrid) {
          while (newGrid.firstElementChild) {
            currentGrid.appendChild(newGrid.firstElementChild);
          }
        }

        const newButton = parsed.querySelector('.collection-page__load-more');
        if (newButton) {
          button.setAttribute('href', newButton.getAttribute('href'));
        } else {
          const pagination = button.closest('.collection-page__pagination');
          if (pagination) {
            if (observer) observer.disconnect();
            pagination.remove();
          }
        }
      } catch (error) {
        console.error('[collection load-more]', error);
      } finally {
        button.dataset.loading = 'false';
      }
    }

    const page = document.querySelector('.collection-page:not(.collection-page--staggered)');
    if (!page) return;

    page.addEventListener('click', (event) => {
      const button = event.target.closest('.collection-page__load-more');
      if (!button) return;
      event.preventDefault();
      loadNext(button);
    });

    const pagination = page.querySelector('.collection-page__pagination');
    if (pagination && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const button = pagination.querySelector('.collection-page__load-more');
          if (button) loadNext(button);
        });
      }, { rootMargin: '800px 0px' });
      observer.observe(pagination);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const video = document.querySelector('.hero__media--video');
    if (!video) return;

    // Kick playback as soon as any data is available; some browsers wait
    // for a user signal or full readiness before honoring autoplay.
    const start = () => {
      const promise = video.play();
      if (promise) promise.catch(() => {});
    };

    if (video.readyState >= 2) {
      start();
    } else {
      video.addEventListener('loadeddata', start, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const el = document.querySelector('.product-page__carousel');
    if (!el) return;

    function init() {
      if (typeof Swiper === 'undefined') {
        requestAnimationFrame(init);
        return;
      }

      const loop = el.hasAttribute('data-carousel-loop');

      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 4,
        freeMode: {
          enabled: true,
          momentumBounce: false,
        },
        grabCursor: true,
        loop: loop,
        loopAdditionalSlides: loop ? 2 : 0,
      });
    }

    init();
  })();

  } catch(e) { console.error(e); }
})();
})();
